// extracted by mini-css-extract-plugin
export default {"posbtnAlt":"pricing_posbtnAlt__ARsDo","link":"pricing_link__7oZzp"};